module.exports = __webpack_public_path__ + "static/img/edu.a78eafde.png";